import { ArrowLeftIcon } from '@radix-ui/react-icons';
import { IconButton } from '@radix-ui/themes';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { MouseEventHandler } from 'react';

export const CommonBackArrow = (props: {
  onClick: MouseEventHandler<HTMLButtonElement>;
}) => (
  <IconButton
    size="1"
    color={RADIX.COLOR.NEUTRAL}
    variant={RADIX.BUTTON.VARIANT.SECONDARY}
    onClick={props.onClick}
  >
    <ArrowLeftIcon />
  </IconButton>
);
